import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <section className="section-pad min-h-[60vh] flex items-center">
        <div className="container-site text-center">
          <p className="accent-script text-gold text-3xl mb-2">404</p>
          <h1 className="heading-serif text-4xl md:text-5xl font-semibold text-navy mb-3">Sayfa Bulunamadı</h1>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.</p>
          <Link to="/" className="btn-gold" data-testid="notfound-home"><Home size={16} /> Ana Sayfaya Dön</Link>
        </div>
      </section>
    </Layout>
  );
}
